// extracted by mini-css-extract-plugin
export var resizer = "_hf-0";